import {
    Avatar,
    Box,
    Divider,
    Icon,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { NoteDto, NoteService } from "../../../api/psc";
import { ConfirmationDialog } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { SnackbarContext } from "../../../contexts/SnackbarContext";
import { UserContext } from "../../../contexts/UserContext";
import { deleteNoteAction } from "../../../slices/SharedActions";
import { toJalaliDate } from "../../../utils/date";
import UpsertNoteDialog from "../dialogs/UpsertNoteDialog";

// updated
export default function NoteItem(props: {
    note: NoteDto;
    projectHashId: string;
}) {
    const note = props.note;
    const dispatch = useDispatch();

    const user = useContext(UserContext);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const { openDialog } = useContext(DialogContext);
    const { showSnackbar } = useContext(SnackbarContext);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const editNote = () => {
        openDialog(
            <UpsertNoteDialog projectHashId={props.projectHashId} note={note} />
        );
    };

    const deleteNote = () => {
        openDialog(
            <ConfirmationDialog
                title="آیا مایل به حذف یادداشت می باشید؟"
                onAccept={() => {
                    NoteService.deleteNote(props.note.id, "1").then((_) => {
                        showSnackbar("یادداشت حذف شد", "success");
                        dispatch(deleteNoteAction(props.note.id));
                    });
                }}
            />
        );
    };

    return (
        <Paper sx={{ p: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar
                    src={note.user.avatarUrl}
                    sx={{ width: 25, height: 25 }}
                />

                <Typography sx={{ flexGrow: 1 }} color="primary">
                    {note.user.displayName}
                </Typography>

                <Typography color="text.secondary" fontSize="small">
                    {toJalaliDate(note.createDate)}
                </Typography>

                {note.user.id === user.id && (
                    <>
                        <IconButton size="small" onClick={handleClick}>
                            <Icon>more_vert</Icon>
                        </IconButton>

                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            <Stack divider={<Divider />}>
                                <MenuItem onClick={editNote}>
                                    <ListItemIcon>
                                        <Icon fontSize="small" color="primary">
                                            edit
                                        </Icon>
                                    </ListItemIcon>
                                    <ListItemText>ویرایش</ListItemText>
                                </MenuItem>

                                <MenuItem onClick={deleteNote} color="error">
                                    <ListItemIcon>
                                        <Icon fontSize="small" color="error">
                                            delete
                                        </Icon>
                                    </ListItemIcon>
                                    <ListItemText>حذف</ListItemText>
                                </MenuItem>
                            </Stack>
                        </Menu>
                    </>
                )}
            </Box>

            <Divider sx={{ my: 1 }} />

            <Typography>{note.content}</Typography>
        </Paper>
    );
}
